var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmsSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 37,
    viewBox: "0 0 42 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2912 27.3523C40.3425 27.3565 40.3894 27.3651 40.4364 27.3779C40.4364 27.3694 40.4364 27.3608 40.4407 27.3523H40.2912ZM21.1281 27.3523V27.3565C21.1281 27.3651 21.1324 27.3694 21.1324 27.3779C21.1794 27.3651 21.2263 27.3565 21.2733 27.3523H21.1281Z",
    stroke: "url(#paint0_linear_3_4)",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4236 24.135C40.257 24.1735 40.082 24.1948 39.9026 24.1948C38.6601 24.1948 37.6567 23.1865 37.6567 21.9474C37.6567 21.1442 38.0709 20.4435 38.7028 20.0461C38.0922 19.2044 37.3578 18.4696 36.5167 17.8586C36.491 17.8415 36.4697 17.8201 36.4441 17.8073C36.0512 18.461 35.3339 18.8968 34.5184 18.8968C33.2758 18.8968 32.2681 17.8885 32.2681 16.6452C32.2681 16.4657 32.2895 16.2905 32.3322 16.1239C31.8284 16.0385 31.3074 16 30.7822 16C30.2485 16 29.719 16.0427 29.2109 16.1282C29.2494 16.2948 29.2664 16.4657 29.2664 16.6452C29.2664 17.8885 28.263 18.8968 27.0205 18.8968C26.2092 18.8968 25.4962 18.4653 25.1033 17.8201C25.0863 17.8287 25.0777 17.8372 25.0606 17.8458C24.2195 18.4567 23.4722 19.2002 22.8659 20.0419C23.4936 20.4392 23.912 21.1442 23.912 21.9474C23.912 23.1865 22.9086 24.1948 21.6661 24.1948C21.4825 24.1948 21.3074 24.1735 21.1409 24.135C21.047 24.6691 21 25.2203 21 25.7885C21 26.3226 21.047 26.8438 21.1281 27.3565H21.2733C21.4014 27.3309 21.5337 27.3181 21.6661 27.3181C21.8027 27.3181 21.9351 27.3309 22.0632 27.3565C23.1178 27.5403 23.912 28.4589 23.912 29.5655C23.912 30.3773 23.4808 31.0951 22.8318 31.4881C22.8446 31.5052 22.8531 31.5181 22.8659 31.5351C23.4851 32.3854 24.2365 33.1331 25.0863 33.7441C25.4791 33.0861 26.2007 32.646 27.0205 32.646C28.263 32.646 29.2664 33.6543 29.2664 34.8934C29.2664 35.0857 29.2451 35.2694 29.1981 35.4446C29.2237 35.4531 29.2494 35.4531 29.2707 35.4574C29.7617 35.5343 30.2699 35.5727 30.7822 35.5727C31.3117 35.5727 31.8326 35.5343 32.3365 35.4531C32.2938 35.2737 32.2681 35.0857 32.2681 34.8934C32.2681 33.6543 33.2758 32.646 34.5184 32.646C35.3467 32.646 36.0683 33.0946 36.4569 33.7569C36.4825 33.7441 36.5038 33.727 36.5295 33.7099C37.3749 33.0904 38.1221 32.3384 38.7284 31.4881C38.088 31.0908 37.6567 30.3773 37.6567 29.5655C37.6567 28.4589 38.4509 27.5403 39.5056 27.3565C39.6336 27.3309 39.766 27.3181 39.9026 27.3181C40.035 27.3181 40.1631 27.3309 40.2912 27.3565H40.4406C40.4406 27.3437 40.4406 27.3309 40.4449 27.3224C40.5218 26.8225 40.5645 26.3098 40.5645 25.7885C40.5645 25.2245 40.5175 24.6691 40.4236 24.135ZM34.7489 26.4208C34.719 26.596 34.6849 26.7627 34.6336 26.925C34.5098 27.3523 34.3134 27.7496 34.0658 28.1043C33.8138 28.4674 33.4979 28.7836 33.1392 29.0442C32.6524 29.3988 32.0845 29.6467 31.4611 29.7535C31.2434 29.7919 31.0128 29.8133 30.778 29.8133C30.5687 29.8133 30.3595 29.7962 30.1588 29.7663C29.5269 29.668 28.9505 29.4245 28.4552 29.0699C28.0965 28.8178 27.7848 28.5059 27.5286 28.1512C27.2639 27.7838 27.0547 27.3694 26.9266 26.925C26.8796 26.7627 26.8412 26.6046 26.8155 26.4379C26.7814 26.2286 26.7643 26.0107 26.7643 25.7928C26.7643 25.5535 26.7814 25.3271 26.8241 25.1006C26.9308 24.4939 27.1699 23.9342 27.5158 23.4514C27.7677 23.101 28.0794 22.7849 28.4338 22.5285C28.9291 22.1739 29.5056 21.9261 30.1289 21.8235C30.3424 21.7851 30.5602 21.7723 30.7822 21.7723C31 21.7723 31.2178 21.7894 31.427 21.8235C32.0589 21.9261 32.6396 22.1739 33.1392 22.5328C33.4893 22.7891 33.801 23.101 34.0529 23.4557C34.3945 23.9342 34.6336 24.4896 34.7404 25.0921C34.7788 25.3228 34.8002 25.5535 34.8002 25.7928C34.8002 26.0021 34.7831 26.2115 34.7489 26.4208Z",
    stroke: "url(#paint1_linear_3_4)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6768 25.1011H13.1766L13.1174 29.2047C13.0977 30.5528 11.4618 31.2111 10.5118 30.2493L5.44648 25.1011H4.08257C2.37967 25.1011 1 23.7215 1 22.0186V4.57955C1 2.87665 2.37967 1.49698 4.08257 1.49698H26.8865C28.5894 1.49698 29.9691 2.87665 29.9691 4.57955V14.3437",
    stroke: "url(#paint2_linear_3_4)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4826 15.9283C16.9478 15.9283 18.1355 14.7406 18.1355 13.2754C18.1355 11.8102 16.9478 10.6225 15.4826 10.6225C14.0175 10.6225 12.8297 11.8102 12.8297 13.2754C12.8297 14.7406 14.0175 15.9283 15.4826 15.9283Z",
    stroke: "url(#paint3_linear_3_4)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57905 15.9283C9.04421 15.9283 10.232 14.7406 10.232 13.2754C10.232 11.8102 9.04421 10.6225 7.57905 10.6225C6.11389 10.6225 4.92615 11.8102 4.92615 13.2754C4.92615 14.7406 6.11389 15.9283 7.57905 15.9283Z",
    stroke: "url(#paint4_linear_3_4)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.39 15.9283C24.8552 15.9283 26.0429 14.7406 26.0429 13.2754C26.0429 11.8102 24.8552 10.6225 23.39 10.6225C21.9249 10.6225 20.7371 11.8102 20.7371 13.2754C20.7371 14.7406 21.9249 15.9283 23.39 15.9283Z",
    stroke: "url(#paint5_linear_3_4)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_4",
    x1: 19.9878,
    y1: 27.3722,
    x2: 20.5932,
    y2: 30.9507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_4",
    x1: -4,
    y1: 31.5,
    x2: 41.8864,
    y2: 31.3449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_4",
    x1: -8,
    y1: 13.5,
    x2: 40.005,
    y2: 12.8953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_4",
    x1: -7,
    y1: 12.5,
    x2: 36,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_4",
    x1: -8.5,
    y1: 14.5,
    x2: 39.5,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_4",
    x1: -8,
    y1: 13,
    x2: 39.5,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsSettings);
export default __webpack_public_path__ + "static/media/SMSSettings.eef82f125938ce86d5d5b160d9abe147.svg";
export { ForwardRef as ReactComponent };